"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerType = void 0;
var OwnerType;
exports.OwnerType = OwnerType;
(function (OwnerType) {
  OwnerType["SERVICE"] = "service";
  OwnerType["PERSON"] = "directowner";
})(OwnerType || (exports.OwnerType = OwnerType = {}));